/* global axios */
import ApiClient from './ApiClient';

// Regra de atendimento da caixa: "Agentes visualizam tudo?" (aba Colaboradores).
// Configurar exige ADMIN da conta — o backend nega para membro comum, senão um
// agente ligaria a chave para si mesmo e passaria a ler a caixa inteira.
class VisaoAgentesAPI extends ApiClient {
  constructor() {
    super('visao_agentes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.baseUrl()}/inboxes/${inboxId}/visao_agentes`);
  }

  save(inboxId, agentesVeemTudo) {
    return axios.post(`${this.baseUrl()}/inboxes/${inboxId}/visao_agentes`, {
      agentes_veem_tudo: agentesVeemTudo,
    });
  }
}

export default new VisaoAgentesAPI();
